import React, { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import HamburgerMenu from '../Common/HamburgerMenu';
import ScrollToBottomButton from '../Common/ScrollToBottomButton';
import './AuthPage.css';

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);

  useEffect(() => {
    // URLパラメータをチェックしてタブを制御
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    
    if (tab === 'signup') {
      setIsLogin(false);
    } else {
      setIsLogin(true);
    }
  }, []);

  return (
    <>
      <div className="App">
        <header className="App-header">
          <div className="header-left">
            <HamburgerMenu />
          </div>
          <div className="header-title" onClick={() => window.location.href = '/landing'} style={{ cursor: 'pointer' }}>
            <img src="/apple-touch-icon.png" alt="Quizenie Icon" className="app-icon" />
            <h1>Quizenie</h1>
          </div>
          <p>クイズで学習しよう！</p>
        </header>

        <main className="App-main">
          <div className="auth-container">
            <div className="auth-toggle">
              <button 
                className={isLogin ? 'active' : ''}
                onClick={() => setIsLogin(true)}
              >
                ログイン
              </button>
              <button 
                className={!isLogin ? 'active' : ''}
                onClick={() => setIsLogin(false)}
              >
                アカウント作成
              </button>
            </div>
            
            {isLogin ? (
              <LoginForm onAuthSuccess={() => window.location.reload()} />
            ) : (
              <SignUpForm onAuthSuccess={() => window.location.reload()} />
            )}
          </div>
        </main>

        <footer className="App-footer">
          <p>&copy; 2025 Quizenie. All rights reserved.</p>
        </footer>
      </div>
      <ScrollToBottomButton />
    </>
  );
};

export default AuthPage;